<ng-container *ngIf="state.loading()">
  <ion-row class="ion-margin-vertical">
    <ion-col>
      <p class="ion-text-center">
        {{ "Loading please wait.." | translate }}
      </p>
    </ion-col>
  </ion-row>
</ng-container>

<ng-container *ngIf="!state.loading()">
  <ng-container *ngIf="!state.eligibileVaccines().length">
    <ion-grid class="vaccines-grid currentVaccinationBg">
      <ion-row class="ion-margin-vertical">
        <ion-col>
          <img src="assets/images/aefireport.svg" class="verified-logo" />
          <p class="ion-text-center">
            {{ "Vaccines are not available for this member" | translate }}
          </p>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-container>
  <ng-container *ngIf="state.eligibileVaccines().length">
    <ion-grid class="vaccines-grid currentVaccinationBg">
      <ion-row class="ion-margin-vertical bgRowClr">
        <ion-col size="12">
          <mat-checkbox color="primary">{{
            "Select all doses for which eligible" | translate
          }}</mat-checkbox>
        </ion-col>
      </ion-row>
      <app-material
        *ngFor="let material of state.eligibileVaccines()"
        [material]="material"
        [isCurrentVaccination]="true"
      ></app-material>
    </ion-grid>
  </ng-container>
</ng-container>
